const ObjectTemplate = (props) => {
  return props.properties.map((element) => element.content);
};

export default ObjectTemplate;
